import React from "react";
import { UserLoggedInNavigatorScreenProps } from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { StoreAdminScreen } from "./StoreAdminScreen";
import { StoreAdminStack } from "./StoreAdminNavigation";
import { useTheme } from "arkh";
import { useIntlTokens } from "../../components/mobile/useIntlTokens";
import { KPIAdmin } from "../KPIAdmin/KPIAdmin/KPIAdmin";
import { ConnectAdminScreen } from "../ConnectAdmin/ConnectAdminScreen";
import { IntegrationsAdminScreen } from "../IntegrationsAdmin/IntegrationsAdminScreen";
import { useIntl } from "react-intl";
import { TeamScheduleAdminSelectTeam } from "../TeamScheduleAdminSelectTeam/TeamScheduleAdminSelectTeam";
import { SuperAdminPanel } from "../StoreSuperAdminPanel/StoreSuperAdminPanel";

import { Platform } from "react-native";
import { HeaderButton } from "../../components";
import { ConnectAdminPreviewScreen } from "../ConnectAdmin/ConnectAdminPreviewScreen";
import { ConnectAdminInboxScreen } from "../ConnectAdmin/ConnectAdminInbox/ConnectAdminInbox";
import { StoreEditNameScreen } from "../StoreEditNameScreen";
import { UserAdminMain } from "../UserAdmin/UserAdminMain";
import { StorecastScreenAdmin } from "../ScreenAdmin/StorecastScreenAdmin";
import { StorecastScreenAdminSelectDashboard } from "../ScreenAdmin/StorecastScreenAdminSelectDashboard";
import { StorecastAdminDeviceList } from "../ScreenAdmin/StorecastAdminDeviceList/StorecastAdminDeviceList";
import { AddScreen } from "../ScreenAdmin/AddScreen/AddScreen";
import { AddScreenScanQR } from "../ScreenAdmin/AddScreenScanQR/AddScreenScanQR";
import { AddScreenSetName } from "../ScreenAdmin/AddScreenSetName";
import { AddScreenInfo } from "../ScreenAdmin/AddScreenInfo/AddScreenInfo";
import { AddScreenSuccess } from "../ScreenAdmin/AddScreenSuccess";
import { AddScreenAssignDashboard } from "../ScreenAdmin/AddScreenAssignDashboard";
import { StorecastScreenAdminAddScheduleItemScreen } from "../ScreenAdmin/StorecastScreenAdminAddScheduleItem";
import { TodoCategoryAdminList } from "../TodoCategoryAdmin/TodoCategoryAdminList";
import { TodoCategoryEditScreen } from "../TodoCategoryAdmin/TodoCategoryEditScreen";
import { TodoCategoryTagCreateScreen } from "../TodoCategoryAdmin/TodoCategoryTagCreateScreen";
import { TodoCategoryTagEditScreen } from "../TodoCategoryAdmin/TodoCategoryTagEditScreen";
import { TodoCategoryCreateScreen } from "../TodoCategoryAdmin/TodoCategoryCreateScreen";
import { withWebModal } from "@/src/TopLevelNavigators/UserLoggedIn/withWebModal";
import { TeamsAdmin } from "./TeamsAdmin";
import { ArchivedTeams } from "./ArchivedTeams";
import { DashboardsAdmin } from "./DashboardsAdmin";
import { AddScreenAssignDashboardPrompt } from "../ScreenAdmin/AddScreenAssignDashboardPrompt/AddScreenAssignDashboardPrompt";

import { IntegrationFlyerCreateScreen } from "../IntegrationsAdmin/IntegrationFlyerCreateScreen";
import { IntegrationFlyerScreen } from "../IntegrationsAdmin/IntegrationFlyerScreen";
import { IntegrationQuinyxCreateScreen } from "../IntegrationsAdmin/IntegrationQuinyxCreateScreen";
import {
  IntegrationSoftOneCreateScreen,
  IntegrationSoftOneOrgCreateScreen,
} from "../IntegrationsAdmin/IntegrationSoftOneCreateScreen";
import { IntegrationTilTidCreateScreen } from "../IntegrationsAdmin/IntegrationTilTidCreateScreen";
import { IntegrationTurnpikeCreateScreen } from "../IntegrationsAdmin/IntegrationTurnpikeCreateScreen";
import { IntegrationInvafreshCreateScreen } from "../IntegrationsAdmin/IntegrationInvafreshCreateScreen";
import {
  IntegrationTomraRvmsScreen,
  IntegrationTomraScreen,
  IntegrationTomraTeamsScreen,
} from "../IntegrationsAdmin/IntegrationTomraScreen";
import { IntegrationNewsfeedCreateScreen } from "../IntegrationsAdmin/IntegrationNewsfeedCreateScreen";
import { IntegrationTomraCreateScreen } from "../IntegrationsAdmin/IntegrationTomraCreateScreen";
import { IntegrationNewsfeedScreen } from "../IntegrationsAdmin/IntegrationNewsfeedScreen";
import { useNavigationHeaderOptions } from "@/src/common/navigationHeaderOptions";
import { TodoCategoryEditGeneralScreen } from "../TodoCategoryAdmin/TodoCategoryEditGeneralScreen";
import { ServiceAccountsScreen } from "../IntegrationsAdmin/ServiceAccountsScreen";
import { ServiceAccountCreateScreen } from "../IntegrationsAdmin/ServiceAccountCreateScreen";
import { TopicsAdmin } from "./TopicsAdmin";
import { IntegrationWebFetcherCreateScreen } from "../IntegrationsAdmin/IntegrationWebFetcherCreateScreen";
import { StorecastScreenAdminEditNameScreen } from "../ScreenAdmin/StorecastScreenAdminEditName";
import { IntegrationICAScreen } from "../IntegrationsAdmin/IntegrationICAScreen";
import { CalendarsAdmin } from "./CalendarsAdmin";
import { ArchivedCalendars } from "./ArchivedCalendars";
import { ConnectAdminSiteAdminScreen } from "../ConnectAdmin/ConnectAdminSiteAdmin/ConnectAdminSiteAdmin";
import { ConnectAdminCreateInitScreen } from "../ConnectAdmin/ConnectAdminCreateInit";
import { IntegrationScreen } from "../IntegrationsAdmin/IntegrationScreen";

export const StoreAdminNavigator = withWebModal(StoreAdminNavigatorC, true);
function StoreAdminNavigatorC(
  props: UserLoggedInNavigatorScreenProps<"StoreAdmin">
) {
  const intl_tokens = useIntlTokens();
  const intl = useIntl();
  const theme = useTheme();

  const getNavigationHeaderOptions = useNavigationHeaderOptions();

  return (
    <StoreAdminStack.Navigator>
      <StoreAdminStack.Screen
        name="StoreAdminMain"
        component={StoreAdminScreen}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "CLOSE",
            onClose() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.Admin,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        name="CalendarsAdmin"
        component={CalendarsAdmin}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.Calendars,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        name="TopicsAdmin"
        component={TopicsAdmin}
        options={{
          headerShown: false,
        }}
      />
      <StoreAdminStack.Screen
        name="TeamsAdmin"
        component={TeamsAdmin}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.Teams,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        name="DashboardsAdmin"
        component={DashboardsAdmin}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.Dashboards,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        name="ArchivedTeams"
        component={ArchivedTeams}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.ArchivedTeams,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        name="ArchivedCalendars"
        component={ArchivedCalendars}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.ArchivedCalendars,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={StoreEditNameScreen}
        name="StoreEditName"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "SAVE-INIT",
            onCancel() {
              navigation.goBack();
            },
            headerTitle: "",
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        options={({ navigation }) => ({
          ...getNavigationHeaderOptions({
            type: "BACK",
            title: intl_tokens.Users,
            onBack() {
              navigation.goBack();
            },
          }),
          contentStyle: {
            backgroundColor: theme["surface-primary"],
          },
          headerTopInsetEnabled: false,
          headerShadowVisible: false,
        })}
        component={UserAdminMain}
        name="UserAdmin"
      />
      <StoreAdminStack.Screen
        component={TodoCategoryAdminList}
        name="TodoCategoryAdminList"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            headerTitle: intl_tokens.CustomLists,
            onBack() {
              navigation.goBack();
            },
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={TodoCategoryCreateScreen}
        name="TodoCategoryCreate"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "CREATE-INIT",
            headerTitle: intl_tokens.Create,
            onCancel() {
              navigation.goBack();
            },
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={TodoCategoryEditScreen}
        name="TodoCategoryEdit"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            headerTitle: "",
            onBack() {
              navigation.goBack();
            },

            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={TodoCategoryEditGeneralScreen}
        name="TodoCategoryEditGeneral"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "SAVE-INIT",
            headerTitle: "",
            onCancel() {
              navigation.goBack();
            },

            defaultContentStyle: true,
          })
        }
      />

      <StoreAdminStack.Screen
        component={TodoCategoryTagCreateScreen}
        name="TodoCategoryTagCreate"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "CREATE-INIT",
            headerTitle: intl.formatMessage({
              defaultMessage: "Create Tag",
              description: "StoreAdminTodoCategories: Create tag header",
            }),
            onCancel() {
              navigation.goBack();
            },

            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={TodoCategoryTagEditScreen}
        name="TodoCategoryTagEdit"
        options={{
          headerTitle: intl.formatMessage({
            defaultMessage: "Edit Tag",
            description: "StoreAdminTodoCategoriesEditTag: Edit Tag header",
          }),
          headerLargeTitle: false,
          headerStyle: {
            backgroundColor: theme.background,
          },
        }}
      />
      <StoreAdminStack.Screen
        component={KPIAdmin}
        name="KPIAdmin"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.KPIs,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={IntegrationsAdminScreen}
        name="IntegrationAdmin"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            headerTitle: intl.formatMessage({
              defaultMessage: "Integrations",
              description: "StoreAdminIntegrationScreen: Header",
            }),
            onBack() {
              navigation.goBack();
            },

            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={ConnectAdminScreen}
        name="ConnectAdmin"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: "",
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={ConnectAdminSiteAdminScreen}
        name="ConnectAdminSiteAdmin"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "SAVE-INIT",
            onCancel() {
              navigation.goBack();
            },
            headerTitle: "",
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={ConnectAdminPreviewScreen}
        name="ConnectAdminPreview"
        options={{
          headerShown: true,
          headerBackVisible: true,
          headerTitle: intl.formatMessage({
            defaultMessage: "Connect Preview",
            description: "Connect Admin Preview",
          }),
          contentStyle: {
            backgroundColor: theme.surface,
          },
        }}
      />
      <StoreAdminStack.Screen
        component={ConnectAdminCreateInitScreen}
        name="ConnectAdminCreateInit"
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            headerTitle: intl.formatMessage({
              defaultMessage: "Create Connect Inbox",
              description: "Connect Admin: Create new inbox header title",
            }),
            defaultContentStyle: true,
            onBack() {
              navigation.goBack();
            },
          })
        }
      />

      <StoreAdminStack.Screen
        component={withWebModal(ConnectAdminInboxScreen, true, {
          width: 1200,
        })}
        name="ConnectAdminInbox"
        options={({ navigation }) => ({
          ...getNavigationHeaderOptions({
            type: "SAVE-INIT",
            onCancel() {
              navigation.goBack();
            },
            headerTitle: "",
            defaultContentStyle: true,
          }),
          presentation: "modal",
        })}
      />

      <StoreAdminStack.Screen
        name="TeamScheduleAdminSelectTeam"
        component={TeamScheduleAdminSelectTeam}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl_tokens.TeamSchedule,
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        component={SuperAdminPanel}
        name="SuperAdminPanel"
        options={{
          title: "Super Admin Panel",
        }}
      />
      <StoreAdminStack.Screen
        name="ScreenList"
        component={StorecastAdminDeviceList}
        options={({ navigation }) =>
          getNavigationHeaderOptions({
            type: "BACK",
            onBack() {
              navigation.goBack();
            },
            headerTitle: intl.formatMessage({
              defaultMessage: "Screens",
              description: "StoreAdmin:Item label screens",
            }),
            defaultContentStyle: true,
          })
        }
      />
      <StoreAdminStack.Screen
        name="ScreenAdmin"
        component={StorecastScreenAdmin}
        options={{
          title: "",
          contentStyle: {
            backgroundColor: theme.background,
          },
        }}
      />
      <StoreAdminStack.Screen
        name="ScreenAdminSelectDashboard"
        component={StorecastScreenAdminSelectDashboard}
        options={{
          title: intl.formatMessage({
            defaultMessage: "Select Dashboard",
            description: "Screen admin select dashboard screen header title",
          }),
        }}
      />
      <StoreAdminStack.Screen
        name="ScreenAdminEditName"
        component={StorecastScreenAdminEditNameScreen}
        options={{
          title: "",
        }}
      />
      <StoreAdminStack.Screen
        name="AddScreen"
        component={AddScreen}
        options={({ navigation }) => ({
          title: "",
          headerLeft: () => (
            <HeaderButton type="CANCEL" onPress={navigation.goBack} />
          ),
        })}
      />
      <StoreAdminStack.Screen
        name="AddScreenScanQR"
        component={AddScreenScanQR}
        options={({ navigation }) => ({
          title: "",
          headerLeft: () => (
            <HeaderButton type="BACK" onPress={navigation.goBack} />
          ),
        })}
      />
      <StoreAdminStack.Screen
        name="AddScreenSetName"
        component={AddScreenSetName}
        options={{ headerShown: true }}
      />
      <StoreAdminStack.Screen
        name="AddScreenInfo"
        component={AddScreenInfo}
        options={{ headerShown: false }}
      />
      <StoreAdminStack.Screen
        name="AddScreenAssignDashboardPrompt"
        component={AddScreenAssignDashboardPrompt}
        options={{ headerShown: false }}
      />

      <StoreAdminStack.Screen
        name="AddScreenSuccess"
        component={AddScreenSuccess}
        options={{ headerShown: false }}
      />
      <StoreAdminStack.Screen
        name="AddScreenAssignDashboard"
        component={AddScreenAssignDashboard}
        options={{
          headerShown: false,
          title: intl.formatMessage({
            defaultMessage: "Select Dashboard",
            description: "Screen admin select dashboard header title",
          }),
        }}
      />
      <StoreAdminStack.Screen
        name="AddOrEditScheduleItem"
        component={StorecastScreenAdminAddScheduleItemScreen}
        options={{
          title: intl.formatMessage({
            defaultMessage: "Schedule Storecast",
            description: "Screen admin schedule storecasts screen title",
          }),
          contentStyle: {
            backgroundColor: theme.background,
          },
        }}
      />

      <StoreAdminStack.Group
        screenOptions={({ navigation }) => ({
          headerShown: true,
          presentation: "modal",
          title: intl_tokens.AddIntegration,
          headerLeft:
            Platform.OS === "ios"
              ? () => (
                  <HeaderButton
                    nativeHeader
                    type="CANCEL"
                    onPress={navigation.goBack}
                  />
                )
              : undefined,

          headerStyle: {
            backgroundColor: theme.surface,
          },

          headerShadowVisible: false,
        })}
      >
        <StoreAdminStack.Screen
          name="IntegrationTurnpikeCreate"
          component={IntegrationTurnpikeCreateScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationWebFetcherCreate"
          component={IntegrationWebFetcherCreateScreen}
        />

        <StoreAdminStack.Screen
          name="Integration"
          component={IntegrationScreen}
        />

        <StoreAdminStack.Screen
          name="IntegrationFlyerCreate"
          component={IntegrationFlyerCreateScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationFlyer"
          component={IntegrationFlyerScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationICAScreen"
          component={IntegrationICAScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationTilTidCreate"
          component={IntegrationTilTidCreateScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationSoftOneCreate"
          component={IntegrationSoftOneCreateScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationSoftOneOrgCreate"
          component={IntegrationSoftOneOrgCreateScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationQuinyxCreate"
          component={IntegrationQuinyxCreateScreen}
        />

        <StoreAdminStack.Screen
          name="IntegrationTomra"
          component={IntegrationTomraScreen}
          options={{
            title: intl.formatMessage({
              description: "IntegrationTomra title",
              defaultMessage: "Tomra Settings",
            }),
          }}
        />
        <StoreAdminStack.Screen
          name="IntegrationTomraCreate"
          component={IntegrationTomraCreateScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationInvafreshCreate"
          component={IntegrationInvafreshCreateScreen}
        />
        <StoreAdminStack.Screen
          name="IntegrationTomraTeams"
          component={IntegrationTomraTeamsScreen}
          options={({ navigation: { goBack } }) => ({
            headerLeft: () => (
              <HeaderButton
                type="BACK"
                customLabel="Tomra Settings"
                onPress={goBack}
              />
            ),
            title: intl.formatMessage({
              description: "IntegrationTomraTeams title",
              defaultMessage: "Teams",
            }),
          })}
        />
        <StoreAdminStack.Screen
          name="IntegrationTomraRvms"
          component={IntegrationTomraRvmsScreen}
          options={({ navigation: { goBack } }) => ({
            headerLeft: () => (
              <HeaderButton
                type="BACK"
                customLabel="Tomra Settings"
                onPress={goBack}
              />
            ),
            title: intl.formatMessage({
              description: "IntegrationTomraRvms title",
              defaultMessage: "RVMs",
            }),
          })}
        />
        <StoreAdminStack.Screen
          name="IntegrationNewsfeed"
          component={IntegrationNewsfeedScreen}
          options={{
            title: intl.formatMessage({
              description: "IntegrationNewsfeed title",
              defaultMessage: "Newsfeed Settings",
            }),
          }}
        />
        <StoreAdminStack.Screen
          name="IntegrationNewsfeedCreate"
          component={IntegrationNewsfeedCreateScreen}
        />

        <StoreAdminStack.Screen
          name="ServiceAccounts"
          component={ServiceAccountsScreen}
          options={{
            title: intl.formatMessage({
              description: "ServiceAccounts title",
              defaultMessage: "External Services",
            }),
          }}
        />
        <StoreAdminStack.Screen
          name="ServiceAccountCreate"
          component={ServiceAccountCreateScreen}
          options={{
            title: intl.formatMessage({
              description: "ServiceAccountCreate title",
              defaultMessage: "Create Key",
            }),
          }}
        />
      </StoreAdminStack.Group>
    </StoreAdminStack.Navigator>
  );
}
